import { createContext, useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import { Avatar, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Grid } from '@mui/material';
import { Check } from 'react-feather';

const ConfirmationDialog = ({ open, options, onCancel, onConfirm }) => {
  const {
    title,
    text,
    Icon,
    iconColor,
    cancelText,
    confirmText,
    confirmButtonProps,
    cancelButtonProps,
    dialogProps
  } = options;

  return (
    <Dialog fullWidth open={open} PaperProps={{ sx: { px: 3, py: 1 } }} {...dialogProps} >
      <Grid container >
        <Grid item>
          <Avatar sx={{ mt: 2, bgcolor: iconColor + ".light", color: iconColor ? iconColor + ".main" : "#000" }} >
            <Icon fontSize="small" />
          </Avatar>
        </Grid>
        <Grid item flex={1}>
          <DialogTitle sx={{ pb: 1 }}>{title}</DialogTitle>
          <DialogContent>
            <DialogContentText>{text}</DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              size='large'
              onClick={onCancel}
              variant="outlined"
              {...cancelButtonProps}
            >
              {cancelText}
            </Button>
            <Button
              onClick={onConfirm}
              size='large'
              variant="contained"
              {...confirmButtonProps}
            >
              {confirmText}
            </Button>
          </DialogActions>
        </Grid>
      </Grid>
    </Dialog>
  );
};

export const ConfirmContext = createContext();

const defaultProps = {
  title: "Tem certeza?",
  text: "",
  Icon: Check,
  iconColor: "",
  color: '',
  dialogProps: {},
  confirmButtonProps: {},
  cancelButtonProps: {},
  cancelText: "Cancelar",
  confirmText: "Confirmar",
}

export const ConfirmProvider = ({ children }) => {

  const [options, setOptions] = useState(defaultProps);
  const [resolveReject, setResolveReject] = useState([]);
  const [resolve] = resolveReject;

  const confirm = useCallback((options = {}) => {
    return new Promise((resolve, reject) => {
      setOptions({ ...defaultProps, ...options });
      setResolveReject([resolve, reject]);
    });
  }, []);

  const handleClose = useCallback(() => {
    setResolveReject([]);
  }, []);

  const handleCancel = useCallback(() => {
    resolve(false);
    handleClose();
  }, [resolve, handleClose]);

  const handleConfirm = useCallback(() => {
    resolve(true);
    handleClose();
  }, [resolve, handleClose]);

  return (
    <>
      <ConfirmContext.Provider
        value={confirm}
      >
        {children}
      </ConfirmContext.Provider>
      <ConfirmationDialog
        open={resolveReject.length === 2}
        options={options}
        onCancel={handleCancel}
        onConfirm={handleConfirm}
      />
    </>
  );
};

ConfirmProvider.propTypes = {
  children: PropTypes.element.isRequired,
};